<!-- Navigation and header -->
<header>

  <!-- Row 1: Utility bar (desktop only) -->
  <div class="top-bar d-none d-lg-flex">
    <div class="container">
      <div class="d-flex justify-content-end align-items-center">
        <a class="me-4" routerLink="/about">About Us</a>
        <a class="me-4" routerLink="/glossary">Glossary</a>
        <a class="me-4" href="/open-account">Contact / Open Account</a>
        <span>Call: <a href="tel:+18888155025" aria-label="Call Investing for Catholics at 888.815.5025">888.815.5025</a></span>
      </div>
    </div>
  </div>

  <!-- Row 2: Main navbar -->
  <nav class="navbar navbar-expand-lg sticky-top navbar-dark">
    <div class="container">

      <a class="navbar-brand" href="/">
        <img src="/assets/svg/investing-for-catholics-logo.svg" width="200" height="50"
          class="d-inline-block align-top brand" alt="Investing for Catholics Logo">
      </a>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">

        <!-- Mobile-only: utility links inside hamburger menu -->
        <ul class="navbar-nav d-lg-none">
          <li class="nav-item"><a class="nav-link" routerLink="/about" (click)="ToggleNavBar()">About Us</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/glossary" (click)="ToggleNavBar()">Glossary</a></li>
          <li class="nav-item"><a class="nav-link" href="/open-account" (click)="ToggleNavBar()">Contact / Open Account</a></li>
          <li class="nav-item"><a class="nav-link" href="tel:+18888155025">&#128222; 888.815.5025</a></li>
        </ul>

        <!-- 4 main dropdowns -->
        <ul class="navbar-nav ms-auto">

          <!-- 1: Catholic Values Investing -->
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Catholic Values Investing
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/strategy" (click)="ToggleNavBar()">Catholic Values Investing</a></li>
              <li><a class="dropdown-item" routerLink="/individuals" (click)="ToggleNavBar()">Individuals &amp; Families</a></li>
              <li><a class="dropdown-item" routerLink="/foundations" (click)="ToggleNavBar()">Foundations &amp; Endowments</a></li>
              <li><a class="dropdown-item" routerLink="/caip" (click)="ToggleNavBar()">Catholic Affiliate Investment Program (CAIP)</a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item" href="https://www.ifa.com/pdfs/annual-stewardship-report.pdf" target="_blank" (click)="ToggleNavBar()">Investment Stewardship Report</a></li>
              <li><a class="dropdown-item" href="https://www.ifa.com/pdfs/revisions-usccb-guidelines-2003-to-2021.pdf" target="_blank" (click)="ToggleNavBar()">USCCB Guidelines</a></li>
              <li><a class="dropdown-item" href="https://www.ifa.com/pdfs/mensuram_bonam.pdf" target="_blank" (click)="ToggleNavBar()">Mensuram Bonam</a></li>
            </ul>
          </li>

          

          <!-- 2: Retirement Plans -->
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
             Retirement Plans
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/retirement" (click)="ToggleNavBar()">Overview</a></li>
              <li><a class="dropdown-item" routerLink="/retirement/secure-act" (click)="ToggleNavBar()">Secure 2.0 Webinar</a></li>
              <li><a class="dropdown-item" routerLink="/portfolios/target-date" (click)="ToggleNavBar()">Target Retirement</a></li>
              <li><a class="dropdown-item" href="https://www.ifa.com/pdfs/ifc-target-date-flyer.pdf" target="_blank" (click)="ToggleNavBar()">Target Date Portfolios</a></li>
            </ul>
          </li>

          <!-- 3: IFC Index Portfolios -->
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              IFC Index Portfolios
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/portfolios" (click)="ToggleNavBar()">All Portfolios</a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item" routerLink="/portfolios/100" (click)="ToggleNavBar()">Portfolio 100</a></li>
              <li><a class="dropdown-item" routerLink="/portfolios/90" (click)="ToggleNavBar()">Portfolio 90</a></li>
              <li><a class="dropdown-item" routerLink="/portfolios/80" (click)="ToggleNavBar()">Portfolio 80</a></li>
              <li><a class="dropdown-item" routerLink="/portfolios/70" (click)="ToggleNavBar()">Portfolio 70</a></li>
              <li><a class="dropdown-item" routerLink="/portfolios/60" (click)="ToggleNavBar()">Portfolio 60</a></li>
              <li><a class="dropdown-item" routerLink="/portfolios/50" (click)="ToggleNavBar()">Portfolio 50</a></li>
              <li><a class="dropdown-item" routerLink="/portfolios/40" (click)="ToggleNavBar()">Portfolio 40</a></li>
              <li><a class="dropdown-item" routerLink="/portfolios/30" (click)="ToggleNavBar()">Portfolio 30</a></li>
              <li><a class="dropdown-item" routerLink="/portfolios/20" (click)="ToggleNavBar()">Portfolio 20</a></li>
              <li><a class="dropdown-item" routerLink="/portfolios/10" (click)="ToggleNavBar()">Portfolio 10</a></li>
            </ul>
          </li>

          <!-- 4: Charts & Resources -->
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" id="navChartsResources" role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
              Charts &amp; Resources
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li><a class="dropdown-item" routerLink="/articles" (click)="ToggleSubNavBar()">Articles</a></li>
              <li><a class="dropdown-item" routerLink="/videos" (click)="ToggleSubNavBar()">Videos</a></li>
              <li><a class="dropdown-item" routerLink="/charts" (click)="ToggleSubNavBar()">Charts</a></li>
              <li><a class="dropdown-item" routerLink="/index-calculator" (click)="ToggleNavBar()">Index Calculator</a></li>
              <li><a class="dropdown-item" routerLink="/resources" (click)="ToggleSubNavBar()">Resources</a></li>
              <li><a class="dropdown-item" routerLink="/fees" (click)="ToggleSubNavBar()">Fees</a></li>
           
              <li class="dropend">  
                <a class="dropdown-item dropdown-toggle" href="#" id="submenuToggle"  
                   data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">  
                  Gallery  
                </a>  
                <ul class="dropdown-menu" aria-labelledby="submenuToggle">  
                  <li><a class="dropdown-item" routerLink="/gallery/on-the-road" (click)="ToggleSubNavBar()">IFC On the Road</a></li>  
                  <!-- <li><a class="dropdown-item" routerLink="/gallery/architecture" (click)="ToggleSubNavBar()">Religious Architecture</a></li>  --> 
                  <li><a class="dropdown-item" routerLink="/gallery" (click)="ToggleSubNavBar()">Art</a></li>  
                </ul>  
              </li> 
            </ul>
             
          </li>

              <li class="nav-item"><a class="nav-link" routerLink="/disclosures" (click)="ToggleNavBar()">Back-testing Disclosures</a></li>
              <li class="nav-item"><a class="nav-link" routerLink="/disclosures/index-data" (click)="ToggleNavBar()">Index Descriptions</a></li>
              <li class="nav-item"><a class="nav-link" href="https://www.ifa.com/pdfs/ifa-form-crs.pdf" target="_blank" (click)="ToggleNavBar()">Form CRS</a></li>

        </ul>
      </div>
    </div>
  </nav>

</header>
